import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 35.47 25.73"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.37 25.63c-5.3-.8-6.4-8.4-4.5-14.8 2-6.4 7.7-12.7 16-10.1 1.22.52 2.32 1.31 3.2 2.3 2.4-2.2 4-2.8 8.4-3 4.5-.3 7.1 2 7 5.5-.1 3.5-1.9 4-4.4 6a61.56 61.56 0 0 1-8.5 5.2v-2.7c2.6-2 6.7-4.2 7.5-7.2.3-1.7 0-4-2.6-4.1-1.7 0-3.2.9-4.2 2.2a18.413 18.413 0 0 0-3.4 11.8c.3 2.3 1.5 5.2 3.9 5.1 4-.9 5.8-2 9-4.1l1.3 2c-3.5 3-6.9 6.1-11.7 6-3.6 0-6.3-1-7.5-3.9-2.7 2.1-5.3 4.4-9.5 3.8Zm6.8-22.6a12.022 12.022 0 0 0-5.6 8.8c-.5 3-.6 6.9 1.6 9 1.7 1 4.3-.9 6.2-2.2-.7-4.7 1-8.5 2-12.7 0-3.1-1.6-4-4.2-2.9Z",
      style: {"fill":"#006fde"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "UX-logo"}) } }